import {
  SET_ACCOUNT_ASSISTANT_QUERIES,
  SET_ACCOUNT_ASSISTANT_CONVERSATION,
  SET_ACCOUNT_ASSISTANT_VIEW,
  SET_ACCOUNT_ASSISTANT_STREAMING_QUERY,
  CLEAR_ALL,
} from '../constants';

interface AccountAssistantState {
  queries: any[];
  conversation_id: string | null;
  view: 'conversation' | 'threads';
  streamingQuery: string | null;
}

const initialState: AccountAssistantState = {
  queries: [],
  conversation_id: null,
  view: 'conversation',
  streamingQuery: null,
};

const accountAssistantReducer = (
  state = initialState,
  { type, payload }: { type: string; payload?: any },
): AccountAssistantState => {
  switch (type) {
    case SET_ACCOUNT_ASSISTANT_QUERIES:
      return { ...state, queries: payload };
    case SET_ACCOUNT_ASSISTANT_CONVERSATION:
      return { ...state, conversation_id: payload };
    case SET_ACCOUNT_ASSISTANT_VIEW:
      return { ...state, view: payload };
    case SET_ACCOUNT_ASSISTANT_STREAMING_QUERY:
      return { ...state, streamingQuery: payload };
    case CLEAR_ALL:
      return { ...initialState };
    default:
      return state;
  }
};

export default accountAssistantReducer;
